import { Box, Link, Text } from '@ksyos/design-system';
import { useSearchParams } from '@ksyos/router';
import { useSelector } from 'react-redux';
import type { IReduxState } from '../../../configureStore';
import { fetch } from '../../../store/fetch';
import { translateKey } from '../../../translate';
import { getLastOsasRequestWithMraReferralLetter } from '../../../utils/getLastOsasc2RequestWithMraReferralLetter';
import { ExternalLink } from '../../elements/atoms/externalLink/ExternalLink';
import { Container } from '../../elements/molecules/container/Container';
import { Main } from '../../elements/molecules/main/Main';
import { PageSection } from '../../elements/molecules/pageSection/PageSection';
import { Footer } from '../../elements/organisms/footer/Footer';
import { Header } from '../../elements/organisms/header/Header';
import { PageWrapper } from '../../elements/organisms/pageWrapper/PageWrapper';

export function MraReferral() {
    const [searchParams] = useSearchParams();
    const requestId = searchParams.get('requestId');

    const requestProcesses = useSelector((state: IReduxState) => state.authentication.requestProcesses);
    const userHasOsasMraReferralLetter = useSelector(
        (state: IReduxState) => state.authentication.userHasOsasMraReferralLetter
    );
    const mraReferralLetter =
        getLastOsasRequestWithMraReferralLetter(requestProcesses)?.customControlData.mraReferralLetter;

    if (!mraReferralLetter && !userHasOsasMraReferralLetter) {
        return null;
    } else {
        return (
            <PageWrapper>
                <Header
                    backButtonText={translateKey('common.home')}
                    backUrl="/"
                    hasBackbutton
                    hasLogoutButton
                />
                <Main>
                    <Container isFluidOnMobile>
                        <Text
                            fontWeight="bold"
                            pb={6}
                            pt={6}
                            size="3xl"
                        >
                            Verwijzing voor MRA
                        </Text>
                        <PageSection bgColor="white">
                            <Box
                                maxWidth={620}
                                pb={6}
                            >
                                <Box pb={6}>
                                    De slaaparts heeft je doorverwezen voor een MRA-beugel. We hebben je doorverwijzing
                                    doorgestuurd naar een van onze partners. Ze bellen je binnenkort, zodat je kunt
                                    kiezen uit 3 tandartsen in jouw buurt.
                                </Box>
                                <Link
                                    color="secondary"
                                    fontWeight="normal"
                                    iconLeft="download"
                                    onClick={onDownloadReferralLetter}
                                    variant="button"
                                >
                                    Download verwijsbrief
                                </Link>
                            </Box>

                            <Box
                                maxWidth={620}
                                pb={6}
                                pt={6}
                            >
                                <Text
                                    fontWeight="bold"
                                    pb={6}
                                    size="2xl"
                                >
                                    Je hebt de MRA-beugel gekregen, wat nu?
                                </Text>
                                <Text>
                                    Nadat je de beugel hebt gekregen, draag je deze 3 maanden. Hierna mag je onze
                                    polikliniek bellen zodat we kunnen bespreken hoe het gaat. Als je in de eerste week
                                    al klachten hebt, bel dan je tandarts. Blijven de klachten aanhouden, bel dan onze
                                    onze polikliniek op{' '}
                                    <ExternalLink href="tel:020-2366533">020 600 00 60</ExternalLink>.
                                </Text>
                            </Box>
                        </PageSection>
                    </Container>
                </Main>
                <Footer />
            </PageWrapper>
        );
    }

    async function onDownloadReferralLetter() {
        if (requestId) {
            const res = await fetch(`/api/patient/mraReferralLetter/${requestId}`, 'GET');

            if (res.status === 200) {
                window.open(`/api/patient/mraReferralLetter/${requestId}`, '_blank');
            }
        }

        if (userHasOsasMraReferralLetter) {
            const res = await fetch('/api/patient/osasMraReferralLetter', 'GET');
            if (res.status === 200) {
                window.open('/api/patient/osasMraReferralLetter', '_blank');
            }
        }
    }
}
